export default {
    GENERAR_KYC_TEST: 'Generar nuevo test de conocimiento',
    KYC_TEST: 'Test de conocimiento',
    mail_1: 'Se enviará un correo electrónico a',
    mail_2: 'para notificar al cliente de la realización de un test de conveniencia, ¿desea continuar?',
    questions: {
        BENEFICIO_EJERCICIO_ANTERIOR: '¿Qué beneficio obtuvo en el ejercicio anterior?',
        CIFRA_ANUAL_ANTERIOR: '¿Cuál fue su cifra anual de negocio en el ejercicio anterior?',
        CUANTOS_EMPLEADOS: '¿Con cuántos empleados cuenta la sociedad?',
        DESARROLLA_ACTIVIDAD_SECTORES: '¿Desarrolla o ha desarrollado actividad en alguno de los siguientes sectores?',
        ESPECIFIQUE_ORIGEN: 'Especifique el origen',
        ESPECIFIQUE_SECTOR: 'Especifique el sector',
        HA_SIDO_DIRECTIVO:
            '¿Ha sido directivo de alguna ONG o fundación, persona de responsabilidad pública familiar o allegado, en los dos últimos años?',
        HORIZONTE_TEMPORAL_INVERSION: '¿Cuál es su horizonte temporal de inversión?',
        INDIQUE_CARGO: 'Indique cargo',
        INDIQUE_CONSIDERACION: 'Indique su consideración',
        INDIQUE_EMPRESA: 'Indique empresa',
        INDIQUE_EN_CUALES: 'Indique en cuales',
        INDIQUE_NUMERO_GIN: 'Indique el número GIN',
        INDIQUE_NUMERO_TIN: 'Indique el número TIN',
        INDIQUE_ORGANIZACION: 'Indique la organización',
        INDIQUE_PAISES: 'Indique paises',
        INDIQUE_PAIS_NIF: 'Indique país y número de identificación fiscal',
        INDIQUE_SECTOR: 'Indique sector',
        INGRESOS_ANUALES: '¿Cuáles son sus ingresos anuales?',
        MARQUE_OPCION: 'Marque por favor la opción que corresponda.',
        NIVEL_FORMACION: '¿Cuál es su nivel de formación?',
        NORMATIVA_CRS: '¿Tiene obligaciones fiscales por residencia o ciudadanía en otro país que no fuera España?',
        NORMATIVA_FATCA: '¿Tiene número de identificación fiscal en EE UU?',
        NOMBRE_ADMINISTRADORES:
            'Si no existe ninguna persona física que posea o controle directa o indirectamente un porcentaje igual o superior al 25% del capital social o de los derechos de voto de la persona jurídica, indique el nombre de todos los administradores:',
        NOMBRE_PERSONAS_25_MAS:
            'Si el inversor es una Fundación, ONG, Entidad Religiosa o Asociación, debe indique la persona o personas físicas que controlen un 25% o más de los derechos de voto del Patronato, junta directiva u órgano de representación:',
        NOMBRE_PERSONAS_25_MENOS:
            'Si no existe ninguna persona física que posea o controle un 25% o más de los derechos de voto del Patronato, junta directiva u órgano de representación, indique el nombre de todos los Patronos o miembros del órgano de representación',
        OBLIGADO_PBC_FT:
            '*¿Es Usted sujeto obligado en materia de PBC/FT en virtud de las previsiones contenidas en el art. 2.1. ñ) de la Ley 10/2010?',
        OPERA_EN_PAISES: '¿Opera principalmente en alguno de estos países?',
        ORIGEN_PATRIMONIO: '¿Cuál es el origen del patrimonio a invertir?',
        PATRIMONIO_FINANCIERO: '¿Cuál es su patrimonio financiero aproximado? No incluye inmuebles ni préstamos',
        PERSONAS_FUNDACION_25_MAS:
            'Si el inversor es una fundación, ONG, entidad religiosa o asociación, debe indicar la persona o personas físicas que controlen un 25% o mas de los derechos de voto del patronato, junta directiva u órgano de representación. Si no existiese ninguna indique el nombre de todos los patrones o miembros del órgano de representación',
        PERSONAS_SOCIEDAD_25_MAS:
            'Indique las personas físicas que en último término poseen o controlan un porcentaje igual o superior al 25% del capital social o de los derechos de voto. Si no existiese ninguna, indique el nombre de todos los administradores',
        PRODUCTOS_FINANCIEROS_3_ANOS:
            '¿En qué productos financieros ha invertido en al menos dos ocasiones en los últimos tres años?',
        SITUACION_LABORAL: '¿Cuál es su situación laboral u ocupación?',
        SOCIEDAD_ACTIVIDAD_SECTORES:
            '¿La sociedad desarrolla o ha desarrollado actividad en alguno de los siguientes sectores?',
        SOCIEDAD_NIF_EEUU: '¿La sociedad tiene número de identificación fiscal en EEUU?',
        SOCIEDAD_OPERA_GAFI:
            '¿La sociedad opera principalmente en países, territorios o jurisdicciones de riesgo (GAFI)?',
        SOCIEDAD_SEGUNDO_PAIS_FISCAL:
            '¿La sociedad tiene un segundo país con obligaciones fiscales por residencia o ciudadanía?',
        TIENE_NIF_EEUU: '¿Tiene número de identificación fiscal en EEUU?',
        TIENE_SEGUNDO_PAIS_OBLIGACION_FISCAL:
            '¿Tiene un segundo país con obligaciones fiscales por residencia o ciudadanía?',
        VOLUMEN_FONDOS_PROPIOS: '¿Cuál es su volumen de Fondos Propios?',
        SI: 'Sí'
    },
    responses: {
        ABOGADOS_OTROS: '*Abogados, procuradores y otros profesionales independientes',
        ACTIVIDAD_EMPRESARIAL: 'Actividad empresarial',
        ADMINISTRACIONES_PUBLICAS: 'Administraciones públicas',
        ANTICUARIO: 'Anticuario',
        BANCA_CORRESPONSAL: 'Banca corresponsal',
        BAZARES: 'Bazares',
        CASA_CAMBIO_MONEDA: 'Casa de cambio de moneda y servicios de envío de dinero',
        CASINO: 'Casino',
        COMERCIANTES_ARTE: 'Comerciantes de arte',
        COMERCIO_ELECTRONICO: 'Comercio electrónico',
        COMERCIO_METALES_JOYERIA: 'Comercio melates preciosos/joyería',
        CONSTRUCCION_INMOBILIARIA: 'Construcción/Inmobiliaria',
        CORTO_PLAZO: 'Corto plazo - Entre 1 y 3 años',
        CUENTA_AJENA: 'Empleado por cuenta ajena',
        CUENTA_PROPIA: 'Trabajador por cuenta propia',
        DEPORTISTAS_PROFESIONALES: 'Deportistas profesionales',
        DESEMPLEADO: 'Desempleado',
        DINERO_ELECTRONICO: 'Dinero electrónico y pasarelas de pago',
        DONACION: 'Donación',
        EDUCACION_BASICA: 'Educación básica',
        EDUCACION_NO_OBLIGATORIA: 'Educación no obligatoria',
        EDUCACION_SUPERIOR_CCEE: 'Educación superior o universitaria ámbito economía',
        EDUCACION_SUPERIOR: 'Educación superior o universitaria',
        ENTIDAD_NO_CLASIFICADA:
            'La entidad no se encuentra en ninguna de las clasificaciones anteriores. La entidad debe considerarse como una. Y, si dispone de un número GIIN arriba indicado.',
        ENTIDAD_PERSONA_ESTADOUNIDENSE: 'La entidad es una persona estadounidense',
        ENTRE_10K_50K: 'Entre 10.000 y 50.000 euros',
        ENTRE_120K_250K: 'Entre 120.000 y 250.000 euros',
        ENTRE_16_30_PERSONAS: 'Entre 16 y 30 personas',
        ENTRE_250K_1M: 'Entre 60.000 y 120.000 euros',
        ENTRE_40K_80K: 'Entre 40.000 y 80.000 euros',
        ENTRE_5_15_PERSONAS: 'Entre 5 y 15 personas',
        ENTRE_500K_2M: 'Entre 500.000 y 2 millones de euros',
        ENTRE_500K_5M: 'Entre 500.000 euros y 5 millones de euros',
        ENTRE_50K_500K: 'Entre 50.000 y 500.000 euros',
        ENTRE_5M_40M: 'Entre 5 y 40 millones de euros',
        ENTRE_60K_120K: 'Entre 60.000 y 120.000 euros',
        ENTRE_80K_150K: 'Entre 80.000 y 150.000 euros',
        ESTUDIANTE: 'Estudiante',
        FABRICACION_ARMAS: 'Fabricación o distribución de armas',
        FINANCIERA_GIN:
            'La entidad es una institución financiera obligada a comunicar información y dispone de número GIIN arriba indicado',
        FIRMAS_AUDITORIA: 'Firmas de auditoría',
        FONDOS_INVERSION_LIBRE:
            'Fondos de inversión libre - hedge funds, productos estructurados, productos derivados.',
        HERENCIA: 'Herencia',
        IMPEXP_AUTOMOVILES: 'Importación/exportación automóviles',
        INDEMNIZACION: 'Indemnización',
        INDUSTRIA_TABACALERA: 'Industria tabacalera',
        INSTITUCION_EXCEPTUADA:
            'La entidad es una institución financiera no obligada a comunicar información, una Institución financiera considerada cumplidora, o un beneficiario efectivo execto o una Institución financiera exceptuada. ',
        INSTITUCION_FATCA_GIN:
            'La entidad es una Institución que tiene delegadas el cumplimiento de sus obligaciones FATCA en una Sponsoring entity con número GIIN arriba indicado',
        INSTITUCION_NO_FATCA: 'La entidad es una Institución financiera no partícipe con FATCA',
        INSTITUCION_OFI:
            'La entidad es una Institución financiera con titulares documentados que sean personas estadounidenses específicas (Owner-documented Financial Institution)',
        JUBILADO: 'Jubilado',
        LARGO_PLAZO: 'Largo plazo - Más de 5 años',
        LOCALES_NOCTURNOS: 'Locales nocturnos',
        LOCUTORIO: 'Locutorio',
        MAS_150K: 'Más de 150.000 euros',
        MAS_1M: 'Más de 1.000.000 euros',
        MAS_2M: 'Más de 2 millones de euros',
        MAS_30_PERSONAS: 'Más de 30 personas',
        MAS_40M: 'Más de 40 millones de euros',
        MAS_500K: 'Más de 500.000 euros',
        MEDIO_PLAZO: 'Medio plazo - Entre 3 y 5 años',
        MENOR: 'Menor',
        MENOS_10K: 'Menos de 10.000 euros',
        MENOS_40K: 'Menos de 40.000 euros',
        MENOS_5_PERSONAS: 'Menos de 5 personas',
        MENOS_500K: 'Menos de 500.000 euros',
        MENOS_50K: 'Menos de 50.000 euros',
        MENOS_60K: 'Menos de 60.000 euros',
        MUY_CORTO_PLAZO: 'Muy corto plazo - Menos de un año',
        NO_FINANCIERA_ACTIVA:
            'La entidad es una Entidad no financiera y activa (al menos un 50% de sus rentas pueden calificarse como ingresos operativos)',
        NO_FINANCIERA_PASIVA:
            'La entidad es una Entidad no financiera y pasiva (menos de un 50% de sus rentas pueden calificarse como ingresos operativos)',
        NO: 'No',
        OTROS_INTERMEDIARIOS_FINANCIEROS: 'Otros intermediarios financieros',
        OTROS: 'Otros',
        RECICLADO_METALES: 'Reciclado de metales',
        RENTA_FIJA:
            'Depósitos, imposiciones e instrumentos de renta fija (bonos, letras, fondos de inversión  y planes de pensiones)',
        RENTA_VARIABLE: 'Instrumentos de renta variable ( acciones, SICAV, fondos de inversión y planes de pensiones)',
        SALARIO: 'Salario',
        SI: 'Sí',
        VENTA_BIENES: 'Venta de bienes',
        VENTA_PORMAYOR: 'Venta al por mayor'
    }
};
